import React from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import { Paper, Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';

const dataFontSize = 16;
const cellFontSize = 24;
const lineHeightMult = 0.9;

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
        marginTop: 5,
        marginBottom: 0,
        overflowX: 'auto',
        borderRadius: 0
    },
    table: {
        minWidth: 700
    },
    header: {
        color: theme.lpb.header.fontWhite,
        whiteSpace: 'nowrap'
    },
    headerBold: {
        fontWeight: 'bolder'     
    },
    headerSel: {
        color: theme.lpb.header.fontWhite
    },
    headerSelBold: {
        color: theme.lpb.header.fontWhite,
        fontWeight: 'bolder'
    },
    row: {
        color: theme.lpb.body.fontWhite,
        textAlign: 'center'
    },
    rowCenter: {
        textAlign: 'center'
    }
}));

const useStylesResult = makeStyles((theme) => {
    const cssObjext = {
        body: {
            fontSize: dataFontSize,
            paddingLeft: 10,
            paddingBottom: 2,
            color: "white",
            background: props => theme.lpb.resultBackgroundColors[props.resValue],
            verticalAlign: 'center',
            lineHeight: lineHeightMult
        },
        header: {
            color: theme.lpb.header.fontWhite,
            fontSize: cellFontSize,
            lineHeight: lineHeightMult
        },
        headerBold: {
            fontWeight: 'bolder',
            fontSize: cellFontSize,
            lineHeight: lineHeightMult
        },
        headerSel: {
            color: theme.lpb.header.fontWhite,
            fontSize: cellFontSize,
            lineHeight: lineHeightMult
        },
        headerSelBold: {
            color: theme.lpb.header.fontWhite,
            fontWeight: 'bolder',
            fontSize: cellFontSize,
            lineHeight: lineHeightMult
        },
        headerCommon: {
            fontSize: cellFontSize,
            lineHeight: lineHeightMult,
            whiteSpace: 'nowrap'
        },
        row: {
            color: theme.lpb.body.fontWhite,
            textAlign: 'center',
            fontSize: cellFontSize,
            lineHeight: lineHeightMult
        },
        rowCenter: {
            textAlign: 'center',
            fontSize: cellFontSize,
            lineHeight: lineHeightMult
        }
    }
    return cssObjext;
});

const columns = [
    {
        key: 'broker',
        name: 'Broker'
    },
    {
        key: 'lotNo',
        name: 'Lot no'
    },
    {
        key: 'price',
        name: 'Price'
    },
    {
        key: 'buyer',
        name: 'Buyer'
    },
    {
        key: 'result',
        name: 'Result'
    },
    {
        key: 'brand',
        name: 'Brand'
    },
    {
        key: 'acofDry',
        name: 'ACOF-Dry'
    },
    {
        key: 'acofScd16',
        name: 'ACOF16'
    },
    {
        key: 'departmentName',
        name: 'Department name'
    }
];

const StyledTableCell = withStyles(theme => ({
    head: {
        backgroundColor: theme.palette.primary.main,
        color: "white",
        fontSize: dataFontSize
    },
    body: {
        fontSize: dataFontSize,
        color: theme.lpb.body.fontBlack75,
        paddingBottom: 2,
        verticalAlign: 'center'
    },
}))(TableCell);

const SelectedTableCell = withStyles(theme => ({
    body: {
        fontSize: dataFontSize,
        color: "white",
        background: theme.lpb.body.fontBlack75,
        paddingBottom: 2,
        verticalAlign: 'center'
    },
}))(TableCell);


const StyledTableRow = withStyles(theme => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.lpb.header.fontBlack5,
        }
    },
}))(TableRow);

const getTableHead = (classes) => {
    return (
        <TableHead>
            <TableRow>
                {columns.map(col => {
                    if (col.key !== "departmentName")
                        return (<StyledTableCell align={getValueAlign(col.key)} key={col.key}><h5 className={classes.header}>{col.name}</h5></StyledTableCell>)
                })}
            </TableRow>
        </TableHead>
    )
};

const trimValue = (value) => {
    if (value === null || value === '' || value.length <= 12)
        return value;

    let trimmedValue = value.substring(0, 12);
    return trimmedValue;
}

const getValueAlign = (columnKey) => {
    if (columnKey === null || columnKey === '')
        return "left";
    if (columnKey === "price" || columnKey === "acofDry" || columnKey === "acofScd16")
        return "right";
    return "left";
}

const CustomeTableCell = (props) => {
    const row = props.row;
    const col = props.col;
    const value = row[col.key];
    const key = row.lotNo + col.key;

    const resultClasses = useStylesResult({ ...props, resValue: value });
    if (value && col.key === "result") {
        if (value === "NB") {
            return (
                <TableCell align="left" className={resultClasses.body} key={key}><h4 className={resultClasses.row}>{value}</h4></TableCell>
            )
        }
        else {
            return (
                <TableCell align="left" className={resultClasses.body} key={key}><h4 className={resultClasses.rowCenter}>{value}</h4></TableCell>
            )
        }
    }
    else if (row.lotNo === props.params.selectedLotNo && !row.salesTransactionEventId) {
        if (col.key === "lotNo" || col.key === "price" || col.key === "buyer") {
            return (
                <SelectedTableCell align={getValueAlign(col.key)} key={key}><h4 className={resultClasses.headerSelBold}><strong>{value}</strong></h4></SelectedTableCell>
            )
        }
        else if (col.key === "brand") {
            return (
                <SelectedTableCell align={getValueAlign(col.key)} key={key}><h4 className={resultClasses.headerSel}>{trimValue(value)}</h4></SelectedTableCell>
            )
        }
        else {
            return (
                <SelectedTableCell align={getValueAlign(col.key)} key={key}><h4 className={resultClasses.headerSel}>{value}</h4></SelectedTableCell>
            )
        }
    }
    else {
        if (col.key === "lotNo" || col.key === "price" || col.key === "buyer") {
            return (
                <StyledTableCell align={getValueAlign(col.key)} key={key}><h4 className={resultClasses.headerBold}><strong>{value}</strong></h4></StyledTableCell>
            )
        }
        else if (col.key === "brand") {
            return (
                <StyledTableCell align={getValueAlign(col.key)} key={key}><h4 className={resultClasses.headerCommon}>{trimValue(value)}</h4></StyledTableCell>
            )
        }
        else {
            return (
                <StyledTableCell align={getValueAlign(col.key)} key={key}><h4 className={resultClasses.headerCommon}>{value}</h4></StyledTableCell>
            )
        }
    }
}

const getTableRow = (row, index, params) => {
    let id = row.lotOfferId;
    return (
        <StyledTableRow key={index}>
            {columns.map(col => {
                if (col.key !== "departmentName") {
                    return (
                        <CustomeTableCell row={row} col={col} key={col.key + index} params={params} />
                    )
                }
            })}
        </StyledTableRow>
    )
};

function SaleDisplayTable(props) {
    const classes = useStyles();
    const selectedLotNo = props.selectedRow.lotNo;
    const params = {
        selectedLotNo
    };

    return (
        <Paper className={`${classes.root}`}>
            <Table className={classes.table} border={1} bordercolor={"#bcbec0"} size="small">
                {getTableHead(classes)}
                <TableBody>
                    {props.rows.map((row, index) => (
                        getTableRow(row, index, params)
                    ))}
                </TableBody>
            </Table>
        </Paper>
    );
}

export default SaleDisplayTable;